import { type ComponentProps } from "react";

const TransactionIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg width="28" height="30" viewBox="0 0 28 30" fill="none" {...props}>
      <g opacity="1">
        <path
          d="M20.9443 1L26.4999 5.97161L20.9443 10.9432"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.5 13.4291V10.9433C1.5 9.62474 2.08532 8.36019 3.12718 7.42783C4.16905 6.49547 5.58213 5.97168 7.05556 5.97168H26.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.05556 28.3436L1.5 23.372L7.05556 18.4004"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.5 15.9146V18.4004C26.5 19.7189 25.9147 20.9835 24.8728 21.9158C23.8309 22.8482 22.4179 23.372 20.9444 23.372H1.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

TransactionIcon.displayName = "TransactionIcon";

export default TransactionIcon;
